export function ExitIcon() {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1627_256)">
        <path
          d="M29.9173 11.5025C29.862 11.3703 29.783 11.2501 29.6822 11.1493L26.4333 7.90037C26.0097 7.47787 25.325 7.47787 24.9015 7.90037C24.4779 8.32394 24.4779 9.00969 24.9015 9.43219L26.3022 10.8329H20.2507C19.6516 10.8329 19.1673 11.3183 19.1673 11.9163C19.1673 12.5143 19.6516 12.9996 20.2507 12.9996H26.3022L24.9014 14.4003C24.4778 14.8239 24.4778 15.5096 24.9014 15.9321C25.1127 16.1445 25.39 16.2496 25.6673 16.2496C25.9447 16.2496 26.222 16.1445 26.4333 15.9321L29.6822 12.6832C29.783 12.5835 29.862 12.4633 29.9173 12.33C30.0267 12.065 30.0267 11.7675 29.9173 11.5025Z"
          fill="#DFE6FA"
        />
        <path
          d="M22.4175 15.1667C21.8184 15.1667 21.3341 15.652 21.3341 16.25V21.6667H17.0008V4.33332C17.0008 3.85557 16.6866 3.43307 16.2284 3.2955L12.466 2.16668H21.3341V7.58337C21.3341 8.18137 21.8184 8.66668 22.4175 8.66668C23.0165 8.66668 23.5008 8.18137 23.5008 7.58337V1.08337C23.5008 0.485316 23.0165 0 22.4175 0H5.08414C5.04514 0 5.01045 0.01625 4.97257 0.0205664C4.92164 0.026 4.87507 0.0346328 4.82632 0.0465664C4.71557 0.0746628 4.60993 0.119988 4.51325 0.180883C4.48944 0.196066 4.46019 0.197133 4.43744 0.214449C4.4287 0.221 4.42545 0.232934 4.41677 0.239434C4.2987 0.332566 4.20014 0.446316 4.12864 0.58175C4.11345 0.611 4.1102 0.642434 4.09832 0.67275C4.06364 0.755066 4.02575 0.83525 4.01275 0.92625C4.00732 0.95875 4.01707 0.989066 4.016 1.0205C4.01494 1.04218 4.00082 1.06168 4.00082 1.08332V22.75C4.00082 23.2668 4.36589 23.7109 4.87182 23.8117L15.7051 25.9784C15.7756 25.9936 15.8471 26 15.9175 26C16.168 26 16.4107 25.9131 16.6043 25.7541C16.7281 25.6525 16.8279 25.5247 16.8965 25.3799C16.965 25.2351 17.0006 25.0769 17.0008 24.9167V23.8334H22.4175C23.0165 23.8334 23.5008 23.3481 23.5008 22.7501V16.25C23.5008 15.652 23.0165 15.1667 22.4175 15.1667Z"
          fill="#DFE6FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1627_256">
          <rect width="30" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
